export default {

    //empty-states
    no_coupons: '¡Upss! No hay cupones',
    text_coupon: 'Empieza creando un nuevo cupón de descuento.',
    new_coupon: 'Nuevo cupón',

}